import {Component, Input} from '@angular/core';
import {TileType51} from "../../../models";
import {
    ControlService,
    IconService,
    ParametersService,
    SubtitlesService,
} from "../../../core";
import {StateService} from "@uirouter/core";

@Component({
    selector: 'tile-peripheral-system-software',
    templateUrl: './tile-peripheral-system-software.component.html',
    styleUrls: ['./tile-peripheral-system-software.component.scss']
})
export class TilePeripheralSystemSoftwareComponent {
    @Input() tile: TileType51;

    constructor(
        private control: ControlService,
        public icon: IconService,
        private parameters: ParametersService,
        private $state: StateService,
        private subtitles: SubtitlesService,
    ) {
    }

    subtitle(val: number): string {
        return this.subtitles.setSubtitle(val);
    }

    goControl() {
        if (this.tile.elementMenu) {
            this.$state.go('control', {
                selectedModuleHash: this.parameters.selectedModuleHash
            });
            this.control.setControl(this.tile.elementMenu);
        }
    }

    getIconName() {
        return this.parameters.urlCompany === 'klimor' ? 'setting-klimor': 'setting'
    }
}
